import { useMemo } from "react";

// Styles
import NOPATAssumptionsViewContainer from "./NOPATAssumptionsView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";
import { useLocation } from "react-router-dom";
import { useBQMQ } from "context/BQMQ.context";

interface NOPATAssumptionsViewProps {}

const NOPATAssumptionsView = ({}: NOPATAssumptionsViewProps) => {
    const location = useLocation();
    const { companies } = useBQMQ();

    const companyId = useMemo(() => {
        return new URLSearchParams(location.search).get("company_id");
    }, [location.search]);

    const company = useMemo(() => {
        if (!companyId) return null;
        return (
            companies.find(
                (c: BQMQDropdownCompany) => String(c.value) === companyId
            ) ?? null
        );
    }, [companyId, companies]);

    const redshiftId = company?.redshift_company_id ?? null;

    const filterString =
        redshiftId != null
            ? `CoreSnapshot/company_id eq ${redshiftId}`
            : undefined;

    return (
        <NOPATAssumptionsViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="1a7ceeaa-ae81-48e6-94dd-ce93dddb519b"
                    workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                    filterString={filterString}
                />
            </div>
        </NOPATAssumptionsViewContainer>
    );
};
export default NOPATAssumptionsView;
